import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  Grid,
  Text,
  UnstyledButton,
  useMantineTheme,
  Skeleton,
  HoverCard,
  Badge,
  Group,
  Button,
} from "@mantine/core";
import CreateTheaterModal from "./CreateTheaterModal";
import CreateSectionModal from "./CreateSectionModal";
import { apiWithInterceptor } from "../../../../api";
import { IconPlus } from "@tabler/icons";
import { showNotification } from "@mantine/notifications";
import { openConfirmModal } from "@mantine/modals";
import { useNavigate, Outlet } from "react-router-dom";

const Theater = () => {
  const theme = useMantineTheme();
  const [openModal, setOpenModal] = useState(false);
  const [openSectionModal, setOpenSectionModal] = useState(false);
  const [Theaters, setTheaters] = useState([]);
  const [theaterId, setTheaterId] = useState("");
  const [deleteTheater, setDelete] = useState(false);
  const [loading, setLoading] = useState(true);
  const skeleton = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const navigate = useNavigate();
  useEffect(() => {
    apiWithInterceptor
      .get(`/theater?relations[]=sections`)
      .then((res) => {
        setTheaters(res.data.array);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [deleteTheater]);

  const openDeleteModal = (id) =>
    openConfirmModal({
      title: "Delete Theater",
      centered: true,
      children: (
        <Text size="sm">
          Are you sure you want to delete this theater? This action is
          destructive and{" "}
          <span style={{ color: "red", fontWeight: "bold" }}>CANNOT</span> be
          undone.
        </Text>
      ),
      labels: { confirm: "Delete Theater", cancel: "Cancel" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        apiWithInterceptor
          .delete(
            `/theater/${id}`,

            setDelete(true)
          )
          .then(function () {
            showNotification({
              title: "Success",
              message: "Theater deleted successfully",
              color: "green",
            });
            setLoading(false);
            setDelete(false);
          })
          .catch(function () {
            showNotification({
              title: "Can't delete this theater",
              message: `this theater is connected to sections and cant be deleted to protect your data if you insist to delete it remove sections first`,
              color: "red",
            });
            setDelete(false);
          });
      },
    });

  return (
    <>
      <Box
        sx={{
          width: "100%",
          maxWidth: "1000px",
          margin: "auto",
        }}
      >
        <Grid>
          <Grid.Col
            xs={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <UnstyledButton
              onClick={() => {
                setOpenModal(true);
              }}
              sx={{ marginTop: "1em", width: "100%" }}
            >
              <Card
                shadow="sm"
                p="lg"
                radius="md"
                withBorder
                sx={{
                  height: "5em",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  transition: ".3s",
                  "&:hover": {
                    borderColor: theme.colors.brand[5],
                    backgroundColor: `${theme.colors.brand[9]}02`,
                  },
                }}
              >
                <Text>Create Theater</Text>
                <IconPlus />
              </Card>
            </UnstyledButton>
          </Grid.Col>
          {loading ? (
            <>
              {skeleton.map((item, index) => {
                return (
                  <Grid.Col
                    key={index}
                    xs={12}
                    lg={4}
                    sm={4}
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Skeleton
                      id={item}
                      sx={{
                        height: "350px",
                        width: "250px",
                        marginTop: "20px",
                      }}
                    />
                  </Grid.Col>
                );
              })}
            </>
          ) : (
            Object.values(Theaters).map((item, index) => (
              <Grid.Col
                xs={12}
                sm={4}
                lg={4}
                key={item.id}
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <HoverCard width={350}>
                  <Card
                    withBorder
                    id={item.id}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    sx={{
                      height: "350px",
                      width: "250px",
                      display: "flex",
                      marginTop: "20px",
                      flexDirection: "column",
                      alignItems: "center",
                      transition: ".3s",
                      "&:hover": {
                        borderColor: theme.colors.brand[5],
                        backgroundColor: `${theme.colors.brand[9]}02`,
                      },
                    }}
                  >
                    <Card.Section
                      withBorder
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <HoverCard.Target>
                        <Text
                          fz="xl"
                          fw={700}
                          mt={15}
                          sx={{
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {item.name}
                        </Text>
                      </HoverCard.Target>
                      <Badge
                        variant="dot"
                        mb={15}
                        mt={15}
                        color={item?.sections?.length === 0 ? "red" : "yellow"}
                      >
                        {item?.sections?.length === 0
                          ? "No Sections"
                          : item?.sections?.length > 1
                          ? `${item?.sections?.length} Sections`
                          : `${item?.sections?.length} Section`}
                      </Badge>
                    </Card.Section>

                    <Card.Section
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Group
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "row",
                        }}
                        position="apart"
                        mt="md"
                        mb="xs"
                      >
                        <Button
                          compact
                          variant="filled"
                          onClick={() => {
                            setOpenSectionModal(true);
                            setTheaterId(item.id);
                          }}
                          sx={{ width: "150px" }}
                        >
                          Add Section
                        </Button>

                        <Button
                          compact
                          variant="filled"
                          onClick={() => {
                            navigate(`/app/theater/sections/${item.id}`);
                          }}
                          sx={{ width: "150px" }}
                        >
                          View Sections
                        </Button>

                        <Button
                          onClick={() => {
                            // setOpenModal(true);
                            // setID(item.id);
                          }}
                          compact
                          variant="filled"
                          sx={{ width: "150px" }}
                        >
                          Edit Theater
                        </Button>

                        <Button
                          compact
                          variant="filled"
                          color="red"
                          uppercase
                          sx={{ width: "150px" }}
                          onClick={() => {
                            openDeleteModal(item.id);
                          }}
                        >
                          Delete Theater
                        </Button>
                      </Group>
                    </Card.Section>
                  </Card>
                  <HoverCard.Dropdown sx={{ borderColor: "#edb40d" }}>
                    <Text size="lg">{item.name}</Text>
                  </HoverCard.Dropdown>
                </HoverCard>
              </Grid.Col>
            ))
          )}
        </Grid>
      </Box>
      <CreateTheaterModal
        setOpenModal={setOpenModal}
        opened={openModal}
        setDelete={setDelete}
      />
      <CreateSectionModal
        setOpenSectionModal={setOpenSectionModal}
        opened={openSectionModal}
        theaterId={theaterId}
      />
    </>
  );
};

export default Theater;
